import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { Title, Spacer } from "@bw/bits"
import { PrixMinus } from "@bw/partials"
import { breakpoints } from "../../../theme"

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 10px;
  grid-row-gap: 20px;

  @media (min-width: ${breakpoints.medium}px) {
    grid-template-columns: repeat(auto-fill, minmax(110px, 174px));
    grid-column-gap: 70px;
  }
`
const PrixMinusMap = ({ contents, title }) => {
  return (
    <Spacer>
      <Title title={title} size="h4" />
      <Grid>
        {contents.map((item, i) => (
          <PrixMinus
            key={i}
            title={item.title}
            price={item.price}
            image={item.image}
            discount={item.discount}
            excerpt={item.excerpt}
            to={item.to}
            href={item.href}
            legal={item.legal}
            titular={item.titular}
          />
        ))}
      </Grid>
    </Spacer>
  )
}

PrixMinusMap.propTypes = {
  title: PropTypes.string.isRequired,
  contents: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      price: PropTypes.string.isRequired,
      image: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
        .isRequired,
      discount: PropTypes.string,
      excerpt: PropTypes.string.isRequired,
      to: PropTypes.string,
      href: PropTypes.string,
    })
  ),
}

export { PrixMinusMap }
